import { PjFieldsProps } from '../Fields.type'
import { ClientDataFields } from './PFClientDataFields'
import { ResponsibleFields } from './ResponsibleFields'

const PfFields = ({ formData, loading, onChange }: PjFieldsProps) => (
  <>
    {/* Caso Pessoa Jurídica: Dados do Cliente */}
    <ClientDataFields formData={formData} onChange={onChange} />

    {/* Seleção Responsável/Representante e nome/email do Representante */}
    <ResponsibleFields formData={formData} onChange={onChange} loading={loading} />
  </>
)

export default PfFields
